<template>
  <!-- 用户下级管理 -->
  <div>
    <el-row>
      <el-col class="pull-left" style="width: 200px; margin-right: 20px">
        <el-input
          size="small"
          v-model="params.uid"
          placeholder="主播UID"
        ></el-input>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-button
        size="small"
        class="pull-left"
        type="primary"
        @click="handleSearch"
        >搜索
      </el-button>
    </el-row>
    <el-row style="padding: 10px 0;" v-if="dataMeta">
      <el-col class="pull-left" style="width: 220px; margin-right: 20px;">
        下级总充值：{{dataMeta.recharg_total2}}
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px;">
        拉新用户总数：{{dataMeta.total}}
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px;">
        拉新充值数：{{dataMeta.recharg_total}}
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px;">
        拉新总充值：{{dataMeta.all_recharge}}
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="id" label="用户ID"></el-table-column>
      <el-table-column prop="name" label="用户名"></el-table-column>
      <el-table-column prop="recharge" label="充值"></el-table-column>
      <el-table-column prop="created_at" label="注册时间"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getApiData } from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1,
      params: {
        uid: undefined,
        start_time: undefined,
        end_time: undefined
      }
    }
  },

  methods: {
    handleSearch() {
      this.page = 1
      this.getTableData()
    },
    getTableData() {
      if (!this.params.uid) {
        return false;
      }
      this.loading = true
      getApiData(`user_anchor_stat`, { page: this.page, uid: this.params.uid, start_time: this.params.start_time, end_time: this.params.end_time, limit: 100 })
        .then(res => {
          this.dataList = res.list
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
